import omit from 'lodash/omit';

export function allIds(state, action) {
  const { estimateId } = action.payload;

  const newList = state.filter(id => id !== estimateId);

  return [...newList];
}

export function byId(state, action) {
  const { estimateId } = action.payload;

  const newState = omit(state, estimateId);

  return { ...newState };
}
